import axios from '../config/axios'
import MarketOperation from '../models/MarketOperation'

export const findAll = () =>
  axios.get<MarketOperation[]>('api/market-operations')

export default { findAll }
